import { useParams, useHistory } from 'react-router-dom';
import PermissionList, { RoleSubmitPayload } from './PermissionList';
import { RolePermission, useRoleDetail, useUpdateRole } from '../Roles.hooks';
import Spin from 'Components/Spin/Spin';
import { useState } from 'react';
import { getAppRoutes } from 'Pages/App/App.constants';
import { Notification } from 'Components';
import { useTranslation } from 'react-i18next';

function ViewRole() {
	const { roleId } = useParams<{ roleId: string }>();
	const history = useHistory();
	const [mode, setMode] = useState<'view' | 'edit'>('view');
	const { t } = useTranslation();
	const { role, permissionList, loading } = useRoleDetail(roleId);
	const [updateRole, { loading: updating }] = useUpdateRole();

	const handleSubmit = async (values: RoleSubmitPayload) => {
		try {
			await updateRole(role, values);
			history.push(getAppRoutes().ROLES);
		} catch (error) {
			Notification.error({
				description: t('errorCodes.genericErrorMessage')
			});
		}
	};

	if (loading || !role || updating) return <Spin />

	return (
		<PermissionList
			mode={mode}
			setMode={setMode}
			loading={updating}
			permissionList={permissionList}
			initialValues={{ roleId: role.id, roleName: role.role, description: role.description, permissions: role.permissions?.map((permission: RolePermission) => permission.id) ?? [] }}
			onCancel={() => history.goBack()}
			onSubmit={handleSubmit}
		/>
	);
}

export default ViewRole;